import { render, staticRenderFns } from "./RoteirizacaoAlocacaoDialog.vue?vue&type=template&id=9041b146&"
import script from "./RoteirizacaoAlocacaoDialog.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoAlocacaoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports